module.exports = __webpack_public_path__ + "img/char_004.56afbb68.png";